import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { DataSubjectRightResponse } from '@interfaces/DataSubjectRight.interface';
import { dataSubjectRight } from '../DataSubjectRight';

export function useDataSubjectRightSubmit() {
  return useMutation<DataSubjectRightResponse, AxiosError, FormData>(
    async (requestData: FormData) => {
      const { data: authData } = await dataSubjectRight.getAccessToken();
      const { data } = await dataSubjectRight.submitDataSubjectRightForm(
        requestData,
        authData.access_token
      );
      return data;
    }
  );
}
